var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleRighBracket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_01_align_center",
    "data-name": "01 align center",
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.105,
    height: 14.001,
    viewBox: "0 0 7.105 14.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16640",
    "data-name": "Path 16640",
    d: "M.824,0,0,.824,5.768,6.593a.584.584,0,0,1,0,.825L.01,13.175.835,14,6.593,8.244a1.751,1.751,0,0,0,0-2.476Z",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRighBracket);
export default __webpack_public_path__ + "static/media/angle-righ-bracket.98a0efb378fb5255ca8acc08c2cfa6ba.svg";
export { ForwardRef as ReactComponent };